module.exports = __webpack_public_path__ + "static/media/pinheiro.c6f69fea.png";